import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { listPosts, deletePost } from "../../../api/cms";

export default function AdminPosts() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = () => {
    setLoading(true);
    listPosts()
      .then((items) => setPosts([...items].sort((a, b) => new Date(b.date) - new Date(a.date))))
      .catch(() => setError("Failed to load posts"))
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this post?")) return;
    await deletePost(id);
    load();
  };

  if (loading) return <p>Loading…</p>;
  if (error) return <p className="text-red-500">{error}</p>;

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold">Posts</h1>
        <Link to="/admin/posts/new" className="bg-bahyellow rounded px-4 py-2 text-sm font-semibold hover:opacity-90">
          + Add post
        </Link>
      </div>
      <div className="bg-white rounded-lg shadow overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-left">
            <tr>
              <th className="px-4 py-3 font-semibold">Title</th>
              <th className="px-4 py-3 font-semibold">Date</th>
              <th className="px-4 py-3" />
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {posts.map((p) => (
              <tr key={p.id}>
                <td className="px-4 py-3 font-medium">{p.title}</td>
                <td className="px-4 py-3 text-gray-500 whitespace-nowrap">
                  {p.date ? new Date(p.date).toLocaleDateString("en-GB") : "—"}
                </td>
                <td className="px-4 py-3 text-right space-x-3 whitespace-nowrap">
                  <Link to={`/admin/posts/${p.id}/edit`} className="text-blue-600 hover:underline">Edit</Link>
                  <button onClick={() => handleDelete(p.id)} className="text-red-500 hover:underline">Delete</button>
                </td>
              </tr>
            ))}
            {posts.length === 0 && (
              <tr><td colSpan={3} className="px-4 py-8 text-center text-gray-400">No posts yet</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
